import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addStatus,
  getStatuss,
  getStatus,
  editStatus,
  deleteStatus,
  getAllStatuss,
} from "../../store/actions/status_action";
import { SEARCH_TERMS } from "../enums/statuss_enum";
// Get All Data
export const useAllStatuss = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.status);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteStatus(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getStatuss({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getStatuss({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getStatuss({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleStatus = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.status);
  useEffect(() => {
    dispatch(getStatus(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateStatus = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addStatus(data));
  };
  return [addData];
};
export const useUpdateStatus = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editStatus(id, data));
  };
  return [updateData];
};

export const useSelectAllStatus = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.status);
    useEffect(() => {
      dispatch(getAllStatuss());
    }, []);
    return [data];
  };            